<template>
<div class="flex justify-center items-center">
  <div
    class="relative align-left outline-none leading-12"
    tabindex=0
    @blur="open = false"
  >
    <div
      class="text-left pl-4 pr-10 text-b2c-grey-600 text-sm
            cursor-pointer w-72 shadow-md rounded-md uppercase"
      :class="isLoading ? 'loader' : {open: open}"
      @click="open = !open"
    >
      {{ selected ? selected.string_layout_type_description : '' }}
    </div>
    <div
      class="text-b2c-grey-600 rounded-b-md text-left w-full text-sm
            shadow-md absolute bg-b2c-grey-100 z-10"
      :class="{selectHide: !open}"
    >
      <div
        class="item text-b2c-grey-600 pl-4 cursor-pointer px-20 uppercase"
        v-for="(option, i) of options"
        :key="i"
        @click="changeSelected(option)"
      >
        {{ option.string_layout_type_description }}
      </div>
    </div>
    <div class="pointer-events-none inset-y-0 absolute
        right-0 flex items-center px-2 pt-1 text-b2c-grey-600">
      <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path d="M9.293 12.95l.707.707L15.657
        8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
      </svg>
    </div>
  </div>

</div>
</template>

<script>
export default {
  props: ['options', 'value', 'isLoading'],

  data() {
    return {
      open: false,
      selected: this.value,
      large: this.isLarge ? this.isLarge : false,
      overflow: this.hasOverflow ? this.hasOverflow : false,
    };
  },

  beforeUpdate() {
    this.selected = this.value;
  },

  methods: {
    changeSelected(option) {
      this.selected = option;
      this.open = false;
      this.$emit('input', option);
    },
  },

};
</script>

<style lang="scss" scoped>

.item:hover {
  background-color: #C62A28;
  color: white;
}

.selectHide {
  display: none;
}
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #8d8d8d;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
